import React, { ComponentProps } from 'react';
import { Select } from 'antd';
import { useQuery } from '@common/hooks';
import { ErrorHandler } from '@common/components';
import { TimeZonesQuery, TimeZonesResponse } from 'works/graphql/time-zones';
import { selectInputFilterHelper } from '@common/services';

type Props = ComponentProps<typeof Select>;

export const TimeZoneSelect = (props: Props) => {
  const { loading, error, data } = useQuery<TimeZonesResponse>(TimeZonesQuery);

  if (error) {
    return (
      <ErrorHandler
        error={error}
        log="TimeZoneSelect"
        messageType="contextual"
      />
    );
  }

  return (
    <Select
      size="large"
      showSearch
      loading={loading}
      getPopupContainer={(trigger) => trigger.parentNode}
      filterOption={(input, option) =>
        selectInputFilterHelper(input, { children: option?.children })
      }
      {...props}
    >
      {data?.timeZones?.map(({ text, value }) => (
        <Select.Option key={text} value={value}>
          {text}
        </Select.Option>
      ))}
    </Select>
  );
};
